import React, { useState } from "react";
import LoginForm from "../login/loginForm";
import Footer from "../footer";
import Intro from "../intro";
import "../login.css";
import OtpForgotForm from "./otpForgotForm";
import EmailOtpForm from "../emailOtp/emailOtpForm";
import SignupForm from "../signUp/SignupForm";
import { useLocation, useNavigate } from "react-router-dom";

function OtpForgot() {
  let navigate = useNavigate();
  const location = useLocation();
  const [otpObject, setOtpObject] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
    otp5: "",
    otp6: "",
  });
  const data = location.state;
  const handlesubmit = (event) => {
    event.preventDefault();
    navigate("/requestotp", { state: { show: true, number: data } });
  };
  return (
    <div className="container" id="otpId">
    <div className="row layout">
      <div className="col-sm-5 login-content-box-wrapper">
        <div className="login-content-box">
          <Intro></Intro>
          <div className="footer_login">
            <Footer></Footer>
          </div>
        </div>
        
      </div>
      <div className="col-sm-7 form-login-wrapper">
          <div className="form_login">
            <form onSubmit={handlesubmit} className="form_align">
              <OtpForgotForm
                otpObject={otpObject}
                setOtpObject={setOtpObject}
                data={data}
              ></OtpForgotForm>
            
              {/* <EmailOtpForm
                otpObject={otpObject}
                setOtpObject={setOtpObject}
                data={data}
              ></EmailOtpForm> */}
            
            </form>
        </div>
      </div>
    </div>
  </div>
    // <div className="container" id="loginId">
    //   <div className="row layout">
    //     <div className="col-sm-5 dummy_box_login">
    //       <div className="dummy_text_login">
    //         <Intro></Intro>
    //       </div>
    //       <div className="footer_login">
    //         <Footer></Footer>
    //       </div>
    //     </div>
    //     <div className="col-sm-7 form_login">
    //       <div className="row p-2">
    //         <div className="form_login">
    //           <form onSubmit={handlesubmit} className="form_align">
    //             <OtpForm
    //               otpObject={otpObject}
    //               setOtpObject={setOtpObject}
    //               data={data}
    //             ></OtpForm>
    //           </form>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
}

export default OtpForgot;
